module.exports = __webpack_public_path__ + "static/media/speaker.2fe3bf98.png";